import { render, staticRenderFns } from "./detailsInventoryLoss.vue?vue&type=template&id=52824eca&scoped=true"
import script from "./detailsInventoryLoss.vue?vue&type=script&lang=js"
export * from "./detailsInventoryLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52824eca",
  null
  
)

export default component.exports